import { AuthPublicService } from './../auth.service';
import { Http } from '@angular/http';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment/moment';
import { DialogService,DialogComponent} from 'ng2-bootstrap-modal';
import {AlertHistoryComponent} from '../alert-history/alert-history.component';
@Component({
  selector: 'app-service-end-date',
  templateUrl: './service-end-date.component.html',
  styleUrls: ['./service-end-date.component.scss']
})
export class ServiceEndDateComponent implements OnInit {

  loading:boolean=true;
  ListPreventiveDetails=[];
  ListOfPreventivebtnEndDateandCurrentdate=[]
  orgId:number;
  userId:number; 
  EndDate:any;
  OrginalEndDate:any;
  StartDate:any;
  SerialNumber=[];
  ListAllHistroyDetails=[];
todayDate:any=moment().format('YYYY-MM-DD');
startingCount:number = 0;
	endingCount:number = 0;
  p: number = 1;
  listContractLevel=[];
  finalArr=[];
  histroy=[];
  clientName:any;
  serialNumber:any;
  mcLocation:any;
  phoneNumber:any;
  email:any;
  make:any;
  model:any;
  hmrHours:any;
  technicianName:any;
  lastServiceType:any;
  lastServiceHours:any;
  yearOfManufacture:any;
  branch:any;
  serviceContractOfferedYear:any;
  contractReference:any;
  noofServiceContractYears:any;
  startDate:any;
  endDate:any;
  noOfservice:any;
  serviceRemainderDays:any;
  currentService:any;  
  ListserviceDetails:any;
  histroyPP:any[] = [];
  ListOfFinalData:any[]=[];
  newextension_err:boolean=false;
  newserialNumber:number;
  newstartdate:any;
  newenddate:any;
  newextensiondate:any;
  extensionUpdateId;
  reqmodelId;
  reqMakeId;
  ServiceContractExtend = [];
  ListAllServcieType = [];
  histroyPr = [];
  ListOfExpiryreport = [];
  ListOfNeedToRenewal = [];
  ListTechnicianName = [];
  techinicianDetails = [];
  AllMakedetails =[];
  AllModalDetails=[];
  ListOfCustomerMaster:any[] = [];
  customerDetails:any[] =[];
  ListbranchDetails=[];
  constructor(private dialogservice:DialogService,private http: Http,private router:Router,private route : ActivatedRoute,public _authservice:AuthPublicService) { }

  ngOnInit() {

    if((this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null)){
      window.location.href = 'https://still.alshirawi.com/highmessaging/';
   } else {
    
     this.orgId=this.route.params['value'].orgId;
     this.userId=this.route.params['value'].userId;
     this._authservice.userId = this.userId;
     this._authservice.orgId = this.orgId;
     console.log('OrgId '+ this.orgId);
     console.log('UserId '+ this.userId);
   }
   this.getAllDetailsFromCustomerMaster ();
   this.getAllServiceTypeDetails();
   this.getTechnicianName();
   this.getmodeldetails();
   this.getmakedetails();
   this.getBranchDetails();
   this.getAllPreventiveMaintenanceDetails();
   console.log(this.todayDate);
  }

	getBranchDetails(){
		let obj={
		 'orgId':this.orgId
		}
		return this.http.post('/api/getbranchdetails',obj).subscribe(res=>{
			 this.ListbranchDetails=res.json();
		})
	 }
  showAlert(){
    this.dialogservice.addDialog(AlertHistoryComponent,{title:'View History',values:this.ListAllHistroyDetails,contractlevelArr:this.listContractLevel,'finalArr':this.finalArr,'customIndex':0})
  }


  getAllDetailsFromCustomerMaster () {
    // this.loading=true;
    let customerObj = {
      'orgId':this.orgId
    }
  		return this.http.post('/api/getCustomerMasterDetails', customerObj).subscribe(
     	res => {
         // this.loading=false;
     		
     		this.ListOfCustomerMaster = res.json();
     		for(var i=0;i<this.ListOfCustomerMaster.length;i++) {
     			let obj = {
     				'Id':this.ListOfCustomerMaster[i]._id,
     				'Name':this.ListOfCustomerMaster[i].customer_Name
     			}
     			this.customerDetails.push(obj);
     		}
      	},(err)=>{
          this.loading=false;
        })
    }
    
    getmakedetails() {
  
      let makeObj = {
        'orgId':this.orgId
      }
      return this.http.post('/api/getMakedetails', makeObj).subscribe(
       res => {
            
         this.AllMakedetails=[];
         let response = res.json();
         if(response.length>0) {
           this.AllMakedetails = response;
           
         }
       },(err)=>{
         this.loading=false;
        
       })
    }

    getmodeldetails() {
      // this.loading=true;
         let modelObj = {
           'orgId':this.orgId
         }
         return this.http.post('/api/getModelDetails', modelObj).subscribe(
          res => {
               
            this.AllModalDetails = [];
            let response = res.json();
            if(response.length>0) {
              this.AllModalDetails =response;
              //this.model = response[0].model.toUpperCase();;
            }
          },(err)=>{
            this.loading=false;
            
          })
       }

       getTechnicianName() {
        // this.loading=true;
          let techObj = {
             'orgId':this.orgId
           }
         return this.http.post('/api/getTechniciansName', techObj).subscribe(
           res => {
                
             // this.loading=false;
               res.json();
             this.ListTechnicianName = res.json();
               let technicianArr = []
               for(var i=0;i<this.ListTechnicianName.length;i++) {
                 let obj = {
                   'label':this.ListTechnicianName[i].FIRST_NAME +' '+ this.ListTechnicianName[i].LAST_NAME,
                   'value':this.ListTechnicianName[i].ID
                 }
                 technicianArr.push(obj);
               }
               this.techinicianDetails = technicianArr;
         },(err)=>{
           this.loading=false;
         })
       }


       getAllServiceTypeDetails() {
        //  this.loading=true;
           let serviceObj = {
              'orgId':this.orgId
            }
            return this.http.post('/api/getServiceTypedetails', serviceObj).subscribe(
              res => {
              // this.loading=false;
                 this.ListAllServcieType = res.json();
              },(err)=>{
                this.loading=false;
                 alert('unable to load make values')
              })
        }
  getCount(){
    if(this.p < Math.ceil(this.ListOfPreventivebtnEndDateandCurrentdate.length/10)){
      this.startingCount = (this.p-1)*10;
      if(this.startingCount == 0){
        this.startingCount = 1;
      }
      this.endingCount = this.p*10;
    } else if(this.p == Math.ceil(this.ListOfPreventivebtnEndDateandCurrentdate.length/10)){
      let count = this.ListOfPreventivebtnEndDateandCurrentdate.length%10;
      this.startingCount = (this.p-1)*10;
      this.endingCount = this.startingCount + count;
      if(this.startingCount == 0){
        this.startingCount = 1;
        this.endingCount = count;
      }
    }
 }

  getAllPreventiveMaintenanceDetails() {
    
      
      let reqPMSObj = {
        'orgId':this.orgId
      }
      return this.http.post('/api/getAllPreventiveMaintenanceDetails',reqPMSObj).subscribe(
       res => {
         
      if(res.json().length>0){
        this.ListPreventiveDetails = res.json();
        console.log("ListPreventiveDetails",this.ListPreventiveDetails);
        for(let pd=0;pd<this.ListPreventiveDetails.length;pd++){
          if(this.todayDate>=this.ListPreventiveDetails[pd].original_end_date){
            this.SerialNumber.push(this.ListPreventiveDetails[pd].serial_Number)
            this.ListOfPreventivebtnEndDateandCurrentdate.push(this.ListPreventiveDetails[pd]);
          }
           
        }
        console.log(this.ListOfPreventivebtnEndDateandCurrentdate);
        this.loading=false;
      }else{
        this.loading=false;
      }
        
        },(err)=>{
          this.loading=false;
        })
    }

    ViewHistory(pmId, SerialNumber){
         
     let ReqObjValue = {
       'pmId':pmId
     }
     return this.http.post('/api/getHistoryDetailsBasedOnContractLevel', ReqObjValue).subscribe(
       res=>{ 
            
         this.ListAllHistroyDetails = [];
         this.listContractLevel=[];
         this.finalArr=[];
         this.loading=false;
         this.histroy = res.json();
         for(let h=0;h<this.histroy.length;h++) {
           for(var k =0;k<this.customerDetails.length;k++) {
               if( this.histroy[0].client_Name == this.customerDetails[k].Id){
                 this.clientName = this.customerDetails[k].Name;
               }
             }
             this.extensionUpdateId = this.histroy[h]._id
             for(let m=0;m<this.AllMakedetails.length;m++ ) {
               if(this.AllMakedetails[m]._id == parseInt(this.histroy[h].make)) {
                 this.make = this.AllMakedetails[m].make;
               }
             }
 
             for(let md=0;md<this.AllModalDetails.length;md++ ) {
               if(this.AllModalDetails[md]._id == parseInt(this.histroy[h].model)) {
                 this.model = this.AllModalDetails[md].model;
               }
             }


             for(let n=0;n<this.ListbranchDetails.length;n++){
              if(this.ListbranchDetails[n]._id==this.histroy[h].branch){
               this.histroy[h].branch=this.ListbranchDetails[n].branchAlias
              }
            }

             for(let t=0;t<this.techinicianDetails.length;t++) {
               if(this.techinicianDetails[t].value == parseInt(this.histroy[h].technician_Name)) {
                 this.technicianName = this.techinicianDetails[t].label;
               }
             }
             for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
               if(this.ListAllServcieType[ls]._id == parseInt(this.histroy[h].last_Service_Type)) {
                 this.lastServiceType = this.ListAllServcieType[ls].servicetype;
               }
             }
             if((this.lastServiceType==undefined||this.lastServiceType=="")&&this.histroy[h].last_Service_Type=="New Vehicle"){
               this.lastServiceType="New Vehicle"
              }
             for(let i=0;i<this.histroy[h].Servicedetails.length;i++) {
               for(let k=0;k<this.ListAllServcieType.length;k++) {
                 if(parseInt(this.histroy[h].Servicedetails[i].service_Type) == this.ListAllServcieType[k]._id) {
                   this.histroy[h].Servicedetails[i].service_Type = this.ListAllServcieType[k].servicetype;
                 }
               }
               
             }
             let histroyObject = {
               'clientName':this.clientName,
               'pmId':this.histroy[h]._id,
               'serialNumber':this.histroy[h].serial_Number,
               'mcLocation':this.histroy[h].mcLocation,
               'phoneNumber':this.histroy[h].phone_Number,
               'email':this.histroy[h].email,
               'make':this.make,
               'modal':this.model,
               'hmr':this.histroy[h].hmr,
               'contractLevel':this.histroy[h].contractLevel,
               'technicianName':this.technicianName,
               'lastserviceType':this.lastServiceType,
               'lastServiceHours':this.histroy[h].last_Service_Hours,
               'yearOfManufacturer':this.histroy[h].year_Of_manufacturer,
               'serviceContractOfferedYear':this.histroy[h].service_Contract_Offered,
               'branch':this.histroy[h].branch,
               'contractRefernce':this.histroy[h].contract_Reference,
               'noofServiceContractYears':this.histroy[h].noofServiceContractYear,
               'startDate':moment(this.histroy[h].start_Date).format("D MMM YYYY"),
               'endDate':moment(this.histroy[h].end_Date).format("D MMM YYYY"),
               'newstartdate':this.histroy[h].start_Date,
               'newenddate':this.histroy[h].end_Date,
               'noOfservice':this.histroy[h].no_Of_Service,
               'serviceRemainderDays':this.histroy[h].remainderday,
               'currentService':this.histroy[h].serviceScheduleDay,
               'ListserviceDetails': this.histroy[h].Servicedetails,
               'lastServiceStatusOfContract':'',
               'histroyPr':[],
               'histroyPp':[],
               'ServiceContractExtend':[]
 
             }
             let clObj = {
               'contractLevel':this.histroy[h].contractLevel
             }
             this.listContractLevel.push(clObj);
             this.ListAllHistroyDetails.push(histroyObject);
             //this.showAlert();
         } //histroy for loop end here
       
         let reqObj = {
           'serialNumber':SerialNumber,
         }
         return this.http.post('/api/getListAllPostPonedHistroy', reqObj).subscribe(
         res=>{ 
           this.loading=false;
       
           let ppHis = res.json();
            this.histroyPP = [];
            this.histroyPr = [];
            if(ppHis.length>0) {
             for(var p=0;p<ppHis.length;p++) {
               if(ppHis[p].type == 'servicePrepone') {
                 let pphis = {
                   'serialNumber':ppHis[p].serialNumber,
                   'postPoned_Taken_Date':moment(ppHis[p].postPoned_Taken_Date,).format("D MMM YYYY"),
                   'contractLevel': ppHis[p].contractLevel,
                   'postPoned_Remainder_Days':ppHis[p].postPoned_Remainder_Days,
                   'schedularNumber':ppHis[p].schedularNumber
                 }
                 this.histroyPr.push(pphis);
                 for(let pr=0;pr<this.ListAllHistroyDetails.length;pr++) {
                   if(this.ListAllHistroyDetails[pr].serialNumber == ppHis[p].serialNumber && this.ListAllHistroyDetails[pr].contractLevel == ppHis[p].contractLevel) {
                     this.ListAllHistroyDetails[pr].histroyPr = this.histroyPr;
                   }
                 } //for loop end here
               } else if(ppHis[p].type == 'servicePostpone') {
                 let pphis = {
                   'serialNumber':ppHis[p].serialNumber,
                   'postPoned_Taken_Date':moment(ppHis[p].postPoned_Taken_Date,).format("D MMM YYYY"),
                   'contractLevel': ppHis[p].contractLevel,
                   'postPoned_Remainder_Days':ppHis[p].postPoned_Remainder_Days,
                   'schedularNumber':ppHis[p].schedularNumber
                 }
                 this.histroyPP.push(pphis);
                 for(let pp=0;pp<this.ListAllHistroyDetails.length;pp++) {
                   if(this.ListAllHistroyDetails[pp].serialNumber == ppHis[p].serialNumber && this.ListAllHistroyDetails[pp].contractLevel == ppHis[p].contractLevel) {
                     this.ListAllHistroyDetails[pp].histroyPp = this.histroyPP;
                   }
                 } //for loop end here
               }
 
               
               
             }
           }
           
           let reqExtendobj = {
             'serialNumber':SerialNumber,
           }
           return this.http.post('/api/getListAllServiceContractExtendHistroy', reqObj).subscribe(
           res=>{ 
                
             this.loading=false;
             let SCExtend = res.json();
             this.ServiceContractExtend = [];
             if(SCExtend.length>0) {
               for(var n=0;n<SCExtend.length;n++) {
                 let SCEobj = {
                   'serialNumber':SCExtend[n].serialNumber,
                   'startdate':moment(SCExtend[n].startdate).format("D MMM YYYY"),
                   'enddate':moment(SCExtend[n].enddate).format("D MMM YYYY"),
                   'contractExtensionDate':moment(SCExtend[n].contractExtensionDate).format("D MMM YYYY")
                 }
                 this.ServiceContractExtend.push(SCEobj);
                 for(let p=0;p<this.ListAllHistroyDetails.length;p++) {
                   if(this.ListAllHistroyDetails[p].serialNumber == SCExtend[n].serialNumber && this.ListAllHistroyDetails[p].contractLevel == SCExtend[n].contractLevel) {
                     this.ListAllHistroyDetails[p].ServiceContractExtend = this.ServiceContractExtend;
                   }
                 } //for loop end here
               }
              
             }
             let statusObj = {
              'pmId':this.ListAllHistroyDetails[0].pmId,
              'serialNumber':this.ListAllHistroyDetails[0].serialNumber
            }
            return this.http.post('/api/serviceStatusChecking_serviceFormAPI', statusObj).subscribe(
            res => {
              
              let response = res.json();
              if(response.length > 0) {
                if(response[response.length-1].service_Scheduler_Number == this.ListAllHistroyDetails[0].noOfservice && response[response.length-1].status == 1) {
                  this.ListAllHistroyDetails[0].lastServiceStatusOfContract = 'completed';
                } else {
                  this.ListAllHistroyDetails[0].lastServiceStatusOfContract = 'notcompleted';
                }
              }
              console.log('Final List ' + this.ListAllHistroyDetails);
            
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
              let finalObj = {
               'datavalue':this.ListAllHistroyDetails,
               'datacount':this.listContractLevel
              }
              this.finalArr.push(finalObj);
              this.showAlert();
            })
             
           },(err)=>{
             this.loading=false;
             console.log(err);
           
           })
           
         },(err)=>{
           this.loading=false;
           console.log(err);
           
         })
         
       },(err)=>{
         this.loading=false;
         console.log(err);
        
       })
 
 
 
     }

}



// WEBPACK FOOTER //
// ./client/app/service-end-date/service-end-date.component.ts